import { HiSquares2X2 } from "react-icons/hi2";

export const TeamsIcon = ({ width, height, color, ...props }) => (
  <HiSquares2X2
    size={width || height || 24}
    color={color || "currentColor"}
    {...props}
  />
);
